<template>
	<div>
		<flCabecalhoForm :msg="_traducao('global', 'obrigatorio')" cls="print-titulo-form-20" :texto="'Seus Dados'" />

		<div class="row">
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.localizacao != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					{{ _traducao('global', 'localizacao') }} :</label
				>
				<input
					v-model="form.localizacao"
					@input="form.localizacao = $event.target.value.toUpperCase()"
					class="form-control input-sm"
				/>
				<p class="help-block" v-show="erro.localizacao != ''">{{ erro.localizacao }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.estado != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Estado:</label
				>
				<input v-model="form.estado" @input="form.estado = $event.target.value.toUpperCase()" class="form-control input-sm" />
				<p class="help-block" v-show="erro.estado != ''">{{ erro.estado }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.pais != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Pais:</label
				>
				<input v-model="form.pais" @input="form.pais = $event.target.value.toUpperCase()" class="form-control input-sm" />
				<p class="help-block" v-show="erro.pais != ''">{{ erro.pais }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.companhia != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Companhia:</label
				>
				<input
					v-model="form.companhia"
					@input="form.companhia = $event.target.value.toUpperCase()"
					class="form-control input-sm"
				/>
				<p class="help-block" v-show="erro.companhia != ''">{{ erro.companhia }}</p>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.status_funcionario != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Status:</label
				>
				<input
					v-model="form.status_funcionario"
					@input="form.status_funcionario = $event.target.value.toUpperCase()"
					class="form-control input-sm"
				/>
				<p class="help-block" v-show="erro.status_funcionario != ''">{{ erro.status_funcionario }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.centro_custo != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Centro de Custos:</label
				>
				<input
					v-model="form.centro_custo"
					@input="form.centro_custo = $event.target.value.toUpperCase()"
					class="form-control input-sm"
				/>
				<p class="help-block" v-show="erro.centro_custo != ''">{{ erro.centro_custo }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.unidade_negocio != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Unidade de Negócios:</label
				>
				<input
					v-model="form.unidade_negocio"
					@input="form.unidade_negocio = $event.target.value.toUpperCase()"
					class="form-control input-sm"
				/>
				<p class="help-block" v-show="erro.unidade_negocio != ''">{{ erro.unidade_negocio }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.job_level != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Job Level:</label
				>
				<input
					v-model="form.job_level"
					@input="form.job_level = $event.target.value.toUpperCase()"
					class="form-control input-sm"
				/>
				<p class="help-block" v-show="erro.job_level != ''">{{ erro.job_level }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.job_role != ''}">
				<label>
					<!-- <span class="no-print">* </span> -->
					Job Role:</label
				>
				<input v-model="form.job_role" @input="form.job_role = $event.target.value.toUpperCase()" class="form-control input-sm" />
				<p class="help-block" v-show="erro.job_role != ''">{{ erro.job_role }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				pais: '',
				localizacao: '',
				companhia: '',
				job_level: '',
				centro_custo: '',
				status_funcionario: '',
				unidade_negocio: '',
				estado: '',
				job_role: ''
			},

			erro: {
				pais: '',
				localizacao: '',
				companhia: '',
				job_level: '',
				centro_custo: '',
				status_funcionario: '',
				unidade_negocio: '',
				estado: '',
				job_role: ''
			}
		}
	},

	methods: {
		editar(form) {
			console.log('form', form)
			this.form = form
		},

		validaForm() {
			this.$emit('seta-dados', this.form)

			return true
		}
	}
}
</script>